import { render, staticRenderFns } from "./QuestionComplainability.vue?vue&type=template&id=135936a2&"
import script from "./QuestionComplainability.vue?vue&type=script&lang=js&"
export * from "./QuestionComplainability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports